import { Input } from './Input'

interface CurrencyInputProps {
  label?: string
  error?: string
  value: number | undefined
  onValueChange: (value: number | undefined) => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  className?: string
  placeholder?: string
}

const FORMAT = new Intl.NumberFormat('es-CO')

/** Input de monto con separador de miles mientras se escribe (ej. 1.500.000) -- un
 * <input type="number"> nativo nunca puede mostrar eso, por eso es type="text" con
 * formateo manual; el valor real que maneja el formulario sigue siendo un numero limpio. */
export function CurrencyInput({
  label,
  error,
  value,
  onValueChange,
  onBlur,
  onKeyDown,
  className,
  placeholder,
}: CurrencyInputProps) {
  const display = value !== undefined && value !== null && !Number.isNaN(value) ? FORMAT.format(value) : ''

  return (
    <Input
      type="text"
      inputMode="numeric"
      label={label}
      error={error}
      value={display}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '')
        onValueChange(digits ? Number(digits) : undefined)
      }}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      className={className}
      placeholder={placeholder}
    />
  )
}
